<span
  *ngIf="responseCodes && responseCodes.length > 0"
  ngbDropdown="ngbDropdown"
>
  <button
    class="btn btn-sm"
    ngbDropdownToggle="ngbDropdownToggle"
    container="body"
    type="button"
  >
    {{ currentStatus.text }}
  </button>
  <ul class="dropdown-menu--reduced-padding" ngbDropdownMenu="ngbDropdownMenu">
    <li *ngFor="let responseCode of responseCodes; trackBy: trackByIndex">
      <a
        (click)="selectResponseStatus(responseCode)"
        ngbDropdownItem="ngbDropdownItem"
        ><i
          class="list-icon glyphicon"
          [ngClass]="{
            'glyphicon-check': responseCode.name === currentStatus.name
          }"
        ></i
        >{{ responseCode.text }}</a
      >
    </li>
  </ul></span
>
